import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {Observable} from "rxjs";
import {Injectable} from "@angular/core";
import {UserService} from "../../service/user.service";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private readonly userService: UserService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const authToken = this.userService.getToken();

    if (authToken) {
      req = req.clone({
        headers: req.headers.set('Authorization', authToken.trim())
      });
    }

    return next.handle(req);
  }

}
